import React from "react";
import { Col, Row } from "antd";
import './style.scss'

const arrs = [
  { name: 'A Blessing in Disguise: The Prospects and Perils of Adversarial Machine Learning, ICML 2020', img: 'https://img.alicdn.com/imgextra/i2/O1CN015JlYVJ1XJcUKB8zkJ_!!6000000002903-2-tps-620-346.png' },
  { name: 'Adversarial Machine Learning in Real-World Computer Vision Systems and Online Challenges (AML-CV), CVPR 2021', img: 'https://img.alicdn.com/imgextra/i3/O1CN01xVT9A01sW5CNxC6fd_!!6000000005773-2-tps-736-350.png' },
  { name: 'Adversarial Robustness in the Real World, ICCV 2021', img: 'https://img.alicdn.com/imgextra/i4/O1CN01SgWQ1s1q3ZJCeO3kr_!!6000000005440-2-tps-488-346.png' },
]
export default function Previous() {
  return <div className="page-previous">
    <div className="previous-title">Previous Workshops</div>
    <div className="previous-con">
      {arrs.map((item, index) => (
        <div className={`item-index${index}`} key={index}>
          <img className='item-img' src={item.img} alt="" />
          <p>{item.name}</p>
        </div>
      ))}
    </div>
  </div>
}
